var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Button,
    {
      staticClass: "border",
      nativeOn: {
        click: function ($event) {
          return _setup.onClick.apply(null, arguments)
        },
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.field.buttonText || "Edit") + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }